import { useActions, useStore, useState } from 'vuex-composition-helpers';
import { FilerProductType } from '@ve/components/hotel/filters/common/store/types';
import { IMapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
import { NAMESPACE as MAP_FOR_SEARCH_DATA } from '@ve/pages/serp/store/SearchDataStore';
import { getCurrentInstance, computed } from 'vue';
import { IMapForSearchDataState } from '@ve/pages/serp/store'

const filtersMappingStoreName = 'mapForFilters';
const datesTabsModuleName = 'mapForDatesTabs';

export default () => {
    const proxy = getCurrentInstance()?.proxy;

    const {
        selectDateManually,
    } = useActions(datesTabsModuleName, ['selectDateManually']);

    const {
        action_isExclusive: setIsExclusive,
        action_productType: setProductType,
        action_operators: setOperators,
        action_block,
    } = useActions(filtersMappingStoreName, ['action_isExclusive', 'action_productType', 'action_operators', 'action_block']);

    const {
        products,
        block,
    } = useState<IMapForFiltersState>(filtersMappingStoreName, ['products', 'block']);

    const {
        searchCountries,
        searchDepartureCity,
    } = useState<IMapForSearchDataState>(MAP_FOR_SEARCH_DATA, ['searchCountries', 'searchDepartureCity']);

    const selectProductTypeFilter = (filerProductType: FilerProductType) => {
        selectDateManually();
        setProductType(filerProductType);
    };

    const selectOperatorFilter = (operators: number[]) => {
        setOperators(operators);
    };

    const changeIsExclusiveFilter = (isExclusive: boolean) => {
        setIsExclusive(isExclusive);
    };

    const selectMealsFilter = (meals: number[]) => {
        proxy?.$root.$emit('meal-filter-changed', meals);
    };

    const changeWarrantedFilter = (warranted: boolean) => {
        proxy?.$root.$emit('warranted-filter-changed', warranted);
    };

    const changeDirectFlightFilter = (directFlight: boolean) => {
        proxy?.$root.$emit('direct-flight-changed', directFlight);
    };
    const blockComputed = computed({
        get: () => block.value,
        set: (value: boolean) => {
            setOperators([]);
            setIsExclusive(false);
            setProductType('all');
            proxy?.$root.$emit('start-search-block', value);
        }
    })

    return {
        selectMealsFilter,
        selectProductTypeFilter,
        selectOperatorFilter,
        changeIsExclusiveFilter,
        changeWarrantedFilter,
        changeDirectFlightFilter,
        block: blockComputed,
        products,
        searchCountries,
        searchDepartureCity,
    };
};